// removed by extract-text-webpack-plugin
module.exports = {"selectLabel":"_26-m9JyMWiSX_JKLrczMLM","selectImg":"HU2FMzT2LegOHSHZo2FnO"};


//////////////////
// WEBPACK FOOTER
// ./src/react/ui/features/ImageInput/ImageInput.styl
// module id = 740
// module chunks = 0